import React, { Fragment } from 'react'
import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import { fullName } from '@modules/form-wizard/utils'
import Swal from 'sweetalert2'
import toastr from '@modules/toastr'
import Modal from 'react-responsive-modal'
import ValidatorForm from 'react-form-validator-core/lib/ValidatorForm'
import Loader from '@shared/loader'
import DateTimeField from '@shared/form-fields/date'
import pha_clinics from '@constants/pha-clinics'
import { getDay } from "date-fns";
import moment from 'moment'

export default class BirthRequest extends React.Component {
  resource = '/pha_appointments'
  form_key = 'pha_appointment'
  defaults = {}

  state = { record: null, loading: false, date: new Date(), clinic: {} }

  componentDidMount() {
    if (this.state?.record?.appointment_date) this.setState({ date: new Date(this.state?.record?.appointment_date) })
  }

  // Delete lines as needed
//   fee           = 99
  free          = true
  postpaid      = false
  skip_location = true
  hide_buttons = {
    status: true,
    deny: false,
  }
  has_appointment = false

  custom_actions = [
    {
      text: 'Escalate To Physician',
      icon: 'chevron-right',
      roles: ['officer'],
      test: r => ['pending', 'processing'].includes(r.application_decision),
      fn: async record => this.escalate(record, 'Escalate to Physician'),
    },
    {
      text: 'Confirm Appointment Date',
      icon: 'chevron-right',
      roles: [['officer', 'senior_officer']],
      test: r => ['pending', 'processing', 'officer viewed'].includes(r.application_decision),
      fn: async record => this.setState({ record })
    },
  ]

  coordinates = null

//   validate = async values => {
//     const update = {}

//     return update
//   }

  foremost = null

  // dateOptions = (form) => {
  //   switch (form.clinics) {
  //     case 'Anaesthesiology':
        
  //       break;
    
  //     default:
  //       break;
  //   }
  // }

  setClinicsList = (form) => {
    const clinics = pha_clinics.filter(x => x.clinic_type == form?.clinic_type).map(x => x.clinic_list).flat()
    // console.log(clinics)

    return clinics.map((x, index) => ({ key: index, label: x.label, value: x.value }))
  }

  // FIELDS
  fields = form => [
    '::Applicant Information',
    {
      name: 'clinic_type',
      label: 'Medical Section',
      options: pha_clinics.map((x, index) => ({ key: index, label: x.clinic_type, value: x.clinic_type })),
      // save: false,
      callback: async (v) => {
        if (form.clinic_type) {
          return { clinics: '' }
        }
      },
    },
    {
      name: 'clinics',
      label: 'Clinic',
      options: this.setClinicsList(form),
      callback: async (v) => {
        if (form.clinic_type) {
          let clinics = pha_clinics.filter(x => x.clinic_type == form?.clinic_type).map(x => x.clinic_list).flat()
          clinics = clinics.filter(x => x.value == v)
          this.setState({ clinic: clinics[0] })
        }
      },
      view: {
        element: (value, form) => (
            <Fragment>
              <h5 className='sub'>Clinic</h5>
              <p>{value}</p>
            </Fragment>
          )
      }
    },
    {
      name: 'appointment_date',
      label: 'Appointment Date',
      type: 'date',
      hint: 'Appointment date is subject to change after review by the clinic',
      hide: true,
      minDate: new Date(),
      filterDate: ((date) => {
        const day = getDay(date);
        const availableDatesByClinic =  () => {
          // console.log(form.clinics)
          let clinics = pha_clinics.filter(x => x.clinic_type == form?.clinic_type).map(x => x.clinic_list).flat()
          clinics = clinics.filter(x => x.value == form.clinics)[0];
          // console.log(clinics);

          if (clinics) {
            const allDates = clinics.dates;
            const dayArr = [0, 6]

            if (allDates['Monday'].from == 'N/A') dayArr.push(1);
            if (allDates['Tuesday'].from == 'N/A') dayArr.push(2);
            if (allDates['Wednesday'].from == 'N/A') dayArr.push(3);
            if (allDates['Thursday'].from == 'N/A') dayArr.push(4);
            if (allDates['Friday'].from == 'N/A') dayArr.push(5);

            // console.log(dayArr);

            return dayArr;
          }
          return [0, 6];
        }

        return !availableDatesByClinic().includes(day);
      }),
      view: {
        element: (value, form) => (
            <Fragment>
              <h5 className='sub'>Appointment Date</h5>
              <p>{moment(value).format('MMMM DD, YYYY hh:mm A')}</p>
            </Fragment>
          )
      }
    },
    {
      name: 'confirmed_appointment_date',
      label: 'Confirmed Appointment Date',
      type: 'date',
      hide: true,
      view: {
        element: (value, form) => form.confirmed_appointment_date ? (
            <Fragment>
              <h5 className='sub'>Confirmed Appointment Date</h5>
              <p>{moment(value).format('MMMM DD, YYYY hh:mm A')}</p>
            </Fragment>
          ) : (
            <Fragment>
              <h5 className='sub'>Confirmed Appointment Date</h5>
              <p>N/A</p>
            </Fragment>
          )
      }
    },
 

    '::SPACER',
    "::Uploads",
    "::Please upload at least one of the following documents",
    {
        name: 'referral_letter_upload',
        label: 'Referral Letter',
        type: 'file:image',
        key: f => f.image[0],
        required: !(form.discharge_letter_upload||form.follow_up_card_upload)
    },
    {
        name: 'discharge_letter_upload',
        label: 'Discharge Letter',
        type: 'file:image',
        key: f => f.image[1],
        required: !(form.referral_letter_upload||form.follow_up_card_upload)
    },
    {
        name: 'follow_up_card_upload',
        label: 'Follow up Card',
        type: 'file:image',
        key: f => f.image[2],
        required: !(form.discharge_letter_upload||form.referral_letter_upload)
    },
  ]

  // Custom Action Functions
    setAppt = async () => {
      const { props, state, resource, form_key } = this
      const { history, location } = props
      const { date, record } = state
  
      this.setState({ loading: true })
  
      try {
        await $app.axios.put(resource + '/update_application', {
          [form_key]: {
            form_num: record.form_num,
            application_decision: 'approved',
            confirmed_appointment_date: new Date(date),
          },
        })
  
        if (location?.state?.view) {
          const view = { ...location.state.view }
          view.application_decision = 'approved'
  
          history.replace(location.pathname, {
            ...location.state,
            view,
          })
        }
  
        toastr.success('Success', 'Application successfully updated')
      } catch (error) {
        console.error(error)
        Swal.fire(
          'Oops...',
          'There has been an error with processing your application',
          'error'
        )
      } finally {
        this.setState({ record: null, loading: false })
      }
    }
  
    async escalate(record) {
      let inputOpts = {
        'escalated': "Escalate to Physician for review",
      }
  
      let value = null

      const firstStep = await Swal.fire({
        icon: 'question',
        title: 'Escalate to Physician',
        html: `
          Forward the application to a physician for review, 
          <strong>${fullName(record.user, 'initial')}</strong>, ${record.clinics} Clinic, for
          <br/>${moment(this.state.record?.appointment_date).format('MMMM DD, YYYY hh:mm A')}?
        `,
        input: 'select',
        inputOptions: inputOpts,
        showCancelButton: true,
        confirmButtonText: 'Send',
      })

      if (firstStep.isDismissed) return
      value = firstStep.value
    
      this.setState({ loading: true })
    
      const { props, resource, form_key } = this
      const { history, location } = props
      const { axios } = $app
    
      try {
        await axios.put(resource + '/update_application', {
          [form_key]: {
            form_num: record.form_num,
            application_decision: value,
          },
        })
    
        if (location.state?.view) {
          const view = { ...location.state.view }
          view.application_decision = 'officer viewed'
    
          history.replace(location.pathname, { ...location.state, view })
        }
    
        toastr.success('Success', 'Application successfully updated')
      } catch (error) {
        console.error(error)
        toastr.error('Error', 'Unable to update application')
        return
      }
    
      this.setState({ loading: false })
    }

  closeModal = () => this.setState({ record: null })
  onChange = date => this.setState({ date })

  // render = () => <Wizard {...SERVICE_PROPS(this)} />

  render = () => (
    <Fragment>
      <Loader loading={this.state.loading} />
      <Wizard {...SERVICE_PROPS(this)} />
      <Modal
        open={!!this.state.record && !this.state.loading}
        onClose={this.closeModal}
        classNames={{ modal: 'w-full sm:w-128' }}
        center
      >
        <header className='modal-header'>
          <h4 className='mb-0'>Confirm Appointment Date</h4>
        </header>
        <ValidatorForm onSubmit={this.setAppt}>
          <article className='modal-body'>
            <label htmlFor='selected_clinic' className='form-label'>
              Selected Clinic
            </label>
            <div name='selected_clinic' className='font-bold'>{this.state.record?.clinics}</div>
          </article>
          <article className='modal-body'>
            <label htmlFor='selected_date' className='form-label'>
              Applicant's selected date
            </label>
            <div name='selected_date' className='font-bold'>{moment(this.state.record?.appointment_date).format('MMMM DD, YYYY hh:mm A')}</div>
          </article>
          <article className='modal-body'>
            <label htmlFor='date' className='form-label'>
              Please set the applicant's appointment date
            </label>
            <DateTimeField
              name='date'
              dateFormat="MMMM d, yyyy h:mm aa"
              timeInputLabel="Time:"
              showTimeInput
              icon={null}
              minDate={new Date()}
              selected={this.state.date}
              value={new Date(this.state.record?.appointment_date)}
              onChange={this.onChange}
              validators={['required']}
              errorMessages={['Please enter a valid date']}
              className='form-control'
              required
            />
          </article>
          <footer className='modal-footer'>
            <button type='button' className='btn' onClick={this.closeModal}>
              Cancel
            </button>
            <button type='submit' className='btn btn-primary'>
              Submit
            </button>
          </footer>
        </ValidatorForm>
      </Modal>
    </Fragment>
  )
}